const imageGallery = document?.querySelectorAll(".image-gallery-section");

imageGallery?.forEach((section) => {
  const imageSliderModal = section?.querySelector(".image-gallery-modal");

  const imageGalleryWrapper = imageSliderModal?.querySelector(
    ".modal-wrapper .modal-content"
  );
  const closeModal = imageSliderModal?.querySelector(".close-btn");
  const prevBtn = imageSliderModal?.querySelector(".prev-btn");
  const nextBtn = imageSliderModal?.querySelector(".next-btn");

  const imageCards = section?.querySelectorAll(".card-wrapper");
  const galleryImages = imageGalleryWrapper?.querySelectorAll(
    ".modal-content-wrapper"
  );
  imageCards?.forEach((item) => {
    item?.addEventListener("click", function (e) {
      galleryImages?.forEach((item) => {
        item.style.display = "none";
      });
      const currentSlide = e?.currentTarget?.dataset?.index;

      imageSliderModal?.classList?.add("active");
      const activeContent = ([...galleryImages] || [])?.[currentSlide - 1];
      if (activeContent) {
        activeContent.style.display = "block";
        imageSliderModal.dataset.slide = currentSlide - 1;
      }
    });
  });

  prevBtn?.addEventListener("click", function () {
    let currentSlide = +imageSliderModal?.dataset?.slide;

    galleryImages?.forEach((item) => {
      item.style.display = "none";
    });

    if (currentSlide === 0) {
      currentSlide = galleryImages?.length - 1;
    } else {
      currentSlide = currentSlide - 1;
    }
    const activeContent = ([...galleryImages] || [])?.[currentSlide];
    if (activeContent) {
      activeContent.style.display = "block";
      imageSliderModal.dataset.slide = currentSlide;
    }
  });
  nextBtn?.addEventListener("click", function () {
    let currentSlide = +imageSliderModal?.dataset?.slide;
    galleryImages?.forEach((item) => {
      item.style.display = "none";
    });

    if (currentSlide === galleryImages?.length - 1) {
      currentSlide = 0;
    } else {
      currentSlide = currentSlide + 1;
    }
    const activeContent = ([...galleryImages] || [])?.[currentSlide];
    if (activeContent) {
      activeContent.style.display = "block";
      imageSliderModal.dataset.slide = currentSlide;
    }
  });

  imageSliderModal?.addEventListener("click", function () {
    imageSliderModal?.classList?.remove("active");
  });

  imageGalleryWrapper?.addEventListener("click", function (e) {
    e?.stopPropagation();
  });

  closeModal?.addEventListener("click", function () {
    imageSliderModal?.classList?.remove("active");
  });
});
